import { Col, Table } from "react-bootstrap";
import React, { useEffect, useState } from "react";
import { useRouteLoaderData } from "react-router-dom";

const FreestyleDeltasCollectionBreakdownTables = ({ averages, collection }) => {
    const { radios } = useRouteLoaderData("root");
    const [radioNames, setRadioNames] = useState([]);

    useEffect(() => {
        async function getRadioNames() {
            const radiosData = (await radios).data;
            setRadioNames(
                radiosData.map(x => {
                    return { radio_id: x.radio_id, radio_name: x.radio_name };
                })
            );
        }
        if (radios) {
            getRadioNames();
        }
    }, [radios]);

    const getRadioName = radio_id => radioNames.find(x => x.radio_id === radio_id)?.radio_name || "";

    // Check if 'averages' and 'collection' exist before rendering the table
    if (!averages || averages.length === 0 || !collection || collection.length === 0) {
        return null; // Or you can return some loading or error state
    }

    return (
        <Col className="col-lg-4 col-xl-3 col-12">
            <Table hover bordered responsive className="freestyle-deltas-cards-table text-center">
                <thead>
                    <tr>
                        <th colSpan={2} className="justify-content-center align-items-center text-center fw-bold fs-6 c-ra-yellow">
                            {collection?.[0]?.collection_name} ({getRadioName(collection[0]?.radio_id)})
                        </th>
                    </tr>
                    <tr>
                        <th>Demographics</th>
                        <th>AVG Deltas</th>
                    </tr>
                </thead>
                <tbody>
                    {averages &&
                        averages.map(average => (
                            <tr key={average.demo_name}>
                                <td>{average.demo_name}</td>
                                <td
                                    className={`text-center fw-bold ${
                                        typeof average.averageDelta === "number"
                                            ? average.averageDelta.toFixed(2) > 0
                                                ? "text-success"
                                                : average.averageDelta.toFixed(2) < 0
                                                ? "text-danger"
                                                : "text-secondary"
                                            : 0
                                    }`}>
                                    {average.averageDelta !== "-" ? average.averageDelta.toFixed(2) : average.averageDelta}
                                </td>
                            </tr>
                        ))}
                </tbody>
            </Table>
        </Col>
    );
};

export default FreestyleDeltasCollectionBreakdownTables;
